var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#A4C639"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7429 111H43.2429L67.8224 41.1818H83.4361L108.05 111H94.5497L75.902 55.5H75.3565L56.7429 111ZM57.1861 83.625H94.0043V93.7841H57.1861V83.625ZM117.246 111V41.1818H143.428C148.791 41.1818 153.291 42.1818 156.928 44.1818C160.587 46.1818 163.348 48.9318 165.212 52.4318C167.098 55.9091 168.041 59.8636 168.041 64.2955C168.041 68.7727 167.098 72.75 165.212 76.2273C163.325 79.7045 160.541 82.4432 156.859 84.4432C153.178 86.4205 148.643 87.4091 143.257 87.4091H125.905V77.0114H141.553C144.689 77.0114 147.257 76.4659 149.257 75.375C151.257 74.2841 152.734 72.7841 153.689 70.875C154.666 68.9659 155.155 66.7727 155.155 64.2955C155.155 61.8182 154.666 59.6364 153.689 57.75C152.734 55.8636 151.246 54.3977 149.223 53.3523C147.223 52.2841 144.643 51.75 141.484 51.75H129.893V111H117.246ZM179.027 111V41.1818H191.675V73.2614H192.527L219.766 41.1818H235.209L208.209 72.5114L235.447 111H220.243L199.413 81.0682L191.675 90.2045V111H179.027Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.826 338.567C260.528 338.567 295.956 305.865 295.956 265.524C295.956 225.183 260.528 192.48 216.826 192.48C173.123 192.48 137.695 225.183 137.695 265.524C137.695 305.865 173.123 338.567 216.826 338.567Z",
    fill: "#A4C639"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.826 247.262H276.826C287.434 247.262 295.956 255.783 295.956 266.392V386.392C295.956 397.001 287.434 405.523 276.826 405.523H156.826C146.217 405.523 137.695 397.001 137.695 386.392V266.392C137.695 255.783 146.217 247.262 156.826 247.262Z",
    fill: "#A4C639"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.652 173.089C271.347 174.567 272.391 178.045 270.826 180.741L240.043 236.219C238.565 238.915 235.087 239.958 232.391 238.393C229.695 236.915 228.652 233.436 230.217 230.741L261 175.262C262.478 172.567 265.956 171.61 268.652 173.089Z",
    fill: "#A4C639"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.346 265.523C124.911 265.523 134.216 274.828 134.216 286.393V360.306C134.216 371.871 124.911 381.176 113.346 381.176C101.781 381.176 92.4766 371.871 92.4766 360.306V286.393C92.4766 274.828 101.781 265.523 113.346 265.523Z",
    fill: "#A4C639"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.26 349.871C198.825 349.871 208.13 359.175 208.13 370.741V444.654C208.13 456.219 198.825 465.523 187.26 465.523C175.695 465.523 166.391 456.219 166.391 444.654V370.741C166.391 359.175 175.695 349.871 187.26 349.871Z",
    fill: "#A4C639"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.826 338.567C260.528 338.567 295.956 305.865 295.956 265.524C295.956 225.183 260.528 192.48 216.826 192.48C173.123 192.48 137.695 225.183 137.695 265.524C137.695 305.865 173.123 338.567 216.826 338.567Z",
    fill: "#A4C639"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M156.826 247.262H276.826C287.434 247.262 295.956 255.783 295.956 266.392V386.392C295.956 397.001 287.434 405.523 276.826 405.523H156.826C146.217 405.523 137.695 397.001 137.695 386.392V266.392C137.695 255.783 146.217 247.262 156.826 247.262Z",
    fill: "#A4C639"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M164.082 173.168C161.387 174.646 160.343 178.124 161.908 180.82L192.691 236.298C194.169 238.994 197.647 240.037 200.343 238.472C203.038 236.994 204.082 233.516 202.517 230.82L171.734 175.429C170.256 172.646 166.778 171.69 164.082 173.168Z",
    fill: "#A4C639"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M319.385 265.602C307.82 265.602 298.516 274.906 298.516 286.471V360.384C298.516 371.949 307.82 381.254 319.385 381.254C330.95 381.254 340.254 371.949 340.254 360.384V286.471C340.254 274.906 330.95 265.602 319.385 265.602Z",
    fill: "#A4C639"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.471 349.949C233.906 349.949 224.602 359.254 224.602 370.819L224.602 444.732C224.602 456.297 233.906 465.601 245.471 465.601C257.036 465.601 266.34 456.297 266.34 444.732V370.819C266.34 359.254 257.036 349.949 245.471 349.949Z",
    fill: "#A4C639"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.219 268.566H299.436Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.219 268.566H299.436",
    stroke: "white",
    strokeWidth: 7.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.306 233.347C182.227 233.347 183.785 231.79 183.785 229.869C183.785 227.948 182.227 226.391 180.306 226.391C178.385 226.391 176.828 227.948 176.828 229.869C176.828 231.79 178.385 233.347 180.306 233.347Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M253.349 233.347C255.27 233.347 256.828 231.79 256.828 229.869C256.828 227.948 255.27 226.391 253.349 226.391C251.428 226.391 249.871 227.948 249.871 229.869C249.871 231.79 251.428 233.347 253.349 233.347Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_443",
    x: 31.2422,
    y: 41.1836,
    width: 208.207,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_443",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApk);
export default __webpack_public_path__ + "static/media/apk.9dcb88e0ac5f5a2a2fa90c47224cdd6f.svg";
export { ForwardRef as ReactComponent };